import React, { useState, useEffect, useRef } from 'react';
import './Step2Sources.css';
import { apiService } from '../../../../services/api';

const Step2Sources = ({ formData, onSetFormData }) => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConnections = async () => {
      try {
        setLoading(true);
        const response = await apiService.getConnections();
        setConnections(response.items || []);
      } catch (error) {
        console.error('Error fetching connections:', error);
        setConnections([]);
      } finally {
        setLoading(false);
      }
    };

    if (formData.type === 'ingest') {
      fetchConnections();
    }
  }, [formData.type]);

  const handleConnectionSelect = (connection) => {
    onSetFormData({
      ...formData,
      source: connection,
      connectionId: connection.id,
      connectionType: connection.connection_type,
      rootPrefix: connection.root_prefix || ''
    });
  };

  // Edit-mode hydration: wizard sets `connectionId` from the API but not the
  // `source` object the dropdown/path-gate need. Once connections load, look
  // up the matching row and populate `source`. One-shot via ref.
  const hydratedFromIdRef = useRef(false);
  useEffect(() => {
    if (hydratedFromIdRef.current) return;
    if (loading) return;
    const haveSourceObj = formData.source && typeof formData.source === 'object' && formData.source.id;
    if (haveSourceObj) {
      hydratedFromIdRef.current = true;
      return;
    }
    if (!formData.connectionId) return;
    const match = connections.find((c) => String(c.id) === String(formData.connectionId));
    if (match) {
      hydratedFromIdRef.current = true;
      onSetFormData({
        ...formData,
        source: match,
        connectionType: match.connection_type,
        rootPrefix: formData.rootPrefix || match.root_prefix || '',
      });
    }
  }, [loading, connections, formData, onSetFormData]);

  const getConnectionDisplayName = (connection) => {
    const TYPE_LABELS = {
      azure_blob: 'Azure Blob',
      aws_s3: 'AWS S3',
      sharepoint: 'SharePoint',
      hosted_pdf: 'Hosted PDF',
    };
    const typeLabel = TYPE_LABELS[connection.connection_type] || connection.connection_type;
    return `${connection.display_name} (${typeLabel})`;
  };

  return (
    <div className="step-content">
      <h3 className="step-title">Source</h3>
      <p className="step-subtitle">Choose the storage connection and where the files live.</p>
      
      <div className="form-field">
        <label>Storage connection</label>
        <select
          className="resui-select"
          value={formData.source?.id || ''}
          onChange={(e) => {
            const selected = connections.find(c => c.id === e.target.value);
            if (selected) {
              handleConnectionSelect(selected);
            }
          }}
          disabled={loading}
        >
          <option value="">Select a connection</option>
          {connections.map((connection) => (
            <option key={connection.id} value={connection.id}>
              {getConnectionDisplayName(connection)}
            </option>
          ))}
        </select>
      </div>

      {formData.source && (
        <div className="form-field">
          <label>Path (Optional)</label>
          <input
            className="resui-input"
            type="text"
            placeholder="Subfolder path inside the container/bucket"
            value={formData.path || formData.rootPrefix || ''}
            onChange={(e) => onSetFormData({ ...formData, path: e.target.value })}
          />
          <p className="form-helper-text">Select the container or folder to watch for new files.</p>
        </div>
      )}
    </div>
  );
};

export default Step2Sources;


